import './dsc-footer.scss'
import '@engie-group/fluid-design-system/lib/components/footer/index.css'
import { type Links, type TMenuLinks } from 'types/footer'
import type { FC } from 'react'
import { NJFooter } from '@engie-group/fluid-design-system-react'

interface DSCFooterProps {
  className?: string
  logoPath?: string
  logoAlt?: string
  sloganText?: string
  menuLists?: TMenuLinks
  links?: Links
}

const DSCFooter: FC<DSCFooterProps> = ({
  className,
  logoPath,
  logoAlt,
  sloganText,
  menuLists,
  links
}: DSCFooterProps) => {
  return (
    <div className="dsc-footer">
      <NJFooter
        {...{ className, logoPath, logoAlt, sloganText, menuLists, links }}
        links={[
          {
            text: 'Privacy Policy',
            url: 'https://agora.engie.com/strapi-files/542'
          },
          {
            text: 'Agora',
            url: 'https://agora.engie.com/'
          },
          {
            text: 'Common Data Hub',
            url: 'https://commondatahub.engie.com/'
          },
          {
            text: 'Common API',
            url: 'https://common.api.engie.com/'
          },
          {
            text: 'Contact',
            url: 'mailto:agora@engie.com'
          }
        ]}
      />
    </div>
  )
}

export { DSCFooter }
